import { TableExcelLight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { useSelector } from 'react-redux'

import { useExportAsExcel } from '@/hooks'
import { selectIsLoading } from '@/store'
import { ExportItem } from '../ExportItem'

interface Props {
  exportable: boolean
}

export const ExportXls: React.FC<Props> = ({ exportable }) => {
  const isFetchingXls = useSelector(selectIsLoading('export_xls'))

  const onClick = useExportAsExcel()

  return (
    <ExportItem
      label="Excel"
      exportable={exportable}
      loading={isFetchingXls}
      icon={TableExcelLight}
      onClick={onClick}
    />
  )
}
